import {
  adminListApplicationsPath,
  adminListFundingPath,
  adminListRegistriesPath,
  adminListAccountsPath,
  adminTreePoolPath,
  adminReportsPath,
  dashboardPath,
  planterDashboardPath,
  adminBulkPath,
  listProjectsPath,
  listPlantingProjectsPath,
  adminListProjectsPath,
  giftingPath,
  blogPath,
  planterToolkitPath,
  supportedProjectsPath,
  dashboardCarbonCalcPath,
  dashboardBudgetCalcPath,
  dashboardToolkitPath,
  donatePath,
  businessPackagesPath,
  becomeAPlanterPath,
  communityPath,
  ourBusinessFundersPath,
  aboutUsPath,
  impactPath,
  individualsFamiliesTakeActionPath,
  businessTakeActionPath,
  giftingBusinessPath
} from 'src/config/paths'

import { LinkOption, LinkOptionType } from './types'

export const buildFunderLinks = (): LinkOption[] => [
  {
    requiresUser: true,
    path: dashboardPath(),
    label: 'Account'
  }
]

export const buildDashboardFunderLinks = (
  isBusiness: boolean
): LinkOption[] => [
  {
    requiresUser: true,
    path: dashboardPath(),
    label: 'Dashboard'
  },
  {
    requiresUser: true,
    path: supportedProjectsPath,
    label: 'Projects'
  },
  {
    requiresUser: true,
    path: dashboardCarbonCalcPath,
    label: 'Carbon calculator'
  },
  {
    requiresUser: true,
    path: dashboardBudgetCalcPath,
    label: 'Funding calculator'
  },
  ...(isBusiness
    ? [
        {
          label: 'Marketing toolkit',
          path: dashboardToolkitPath,
          requiresUser: true
        }
      ]
    : []),
  {
    label: 'Fund native trees',
    path: donatePath(),
    requiresUser: true
  },
  {
    label: 'Gifting',
    path: giftingPath,
    requiresUser: true
  }
]

export const buildPlanterLinks = (): LinkOption[] => [
  {
    requiresUser: true,
    path: planterDashboardPath(),
    label: 'Dashboard'
  },
  {
    requiresUser: true,
    label: 'Projects',
    path: listProjectsPath
  },
  {
    requiresUser: true,
    label: 'Planter toolkit',
    path: planterToolkitPath
  }
]

export const buildPublicLinks = (): LinkOption[] => [
  {
    label: 'For individuals',
    requiresUser: false,
    options: [
      {
        type: LinkOptionType.Link,
        label: 'Overview',
        path: individualsFamiliesTakeActionPath
      },
      {
        type: LinkOptionType.Link,
        label: 'Gift a tree',
        path: giftingPath
      }
    ]
  },
  {
    label: 'For businesses',
    requiresUser: false,
    options: [
      {
        type: LinkOptionType.Link,
        label: 'Overview',
        path: businessTakeActionPath
      },
      {
        type: LinkOptionType.Link,
        label: 'Business packages',
        path: businessPackagesPath()
      },
      {
        type: LinkOptionType.Link,
        label: 'Business gifting',
        path: giftingBusinessPath
      },
      {
        type: LinkOptionType.Link,
        label: 'Our business funders',
        path: ourBusinessFundersPath()
      }
    ]
  },
  {
    label: 'Impact',
    requiresUser: false,
    options: [
      {
        type: LinkOptionType.Link,
        label: 'Our impact',
        path: impactPath
      },
      {
        type: LinkOptionType.Link,
        label: 'News and stories',
        path: blogPath()
      }
    ]
  },
  {
    label: 'Projects',
    requiresUser: false,
    path: listPlantingProjectsPath()
  },
  {
    label: 'About',
    requiresUser: false,
    options: [
      {
        label: 'About us',
        path: aboutUsPath,
        type: LinkOptionType.Link
      },
      {
        label: 'Our community',
        path: communityPath,
        type: LinkOptionType.Link
      },
      {
        label: 'Become a planter',
        path: becomeAPlanterPath,
        type: LinkOptionType.Link
      }
    ]
  }
]

export const buildAdvisorLinks = (): LinkOption[] => [
  {
    label: 'Projects',
    path: adminListProjectsPath,
    requiresUser: true
  },
  {
    label: 'Applications',
    path: adminListApplicationsPath(),
    requiresUser: true
  }
]

export const buildAdminLinks = (): LinkOption[] => [
  {
    label: 'Dashboard',
    path: adminTreePoolPath,
    requiresUser: true,
    options: [
      {
        type: LinkOptionType.Link,
        label: 'Tree pool',
        path: adminTreePoolPath
      },
      {
        type: LinkOptionType.Link,
        label: 'Reports',
        path: adminReportsPath
      },
      {
        type: LinkOptionType.Link,
        label: 'Bulk Gifts',
        path: adminBulkPath
      }
    ]
  },
  { label: 'Funding', path: adminListFundingPath, requiresUser: true },
  {
    label: 'Projects',
    path: adminListProjectsPath,
    requiresUser: true
  },
  {
    label: 'Applications',
    path: adminListApplicationsPath(),
    requiresUser: true
  },
  {
    label: 'People',
    path: adminListAccountsPath,
    requiresUser: true,
    options: [
      {
        type: LinkOptionType.Link,
        label: 'Accounts',
        path: adminListAccountsPath
      },
      {
        type: LinkOptionType.Link,
        label: 'Registries',
        path: adminListRegistriesPath
      }
    ]
  }
]
